export default "__VITE_ASSET__DyCyWkbi__"